let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eXTT6")).then(() => parcelRequire('2kLjA'));